import React, { useState } from 'react';
import Logo from "../components/img/Logo.png";
import './Navbar.css';
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import About from './About';
import Home from './Home';
import ContactUs from './ContactUs';
import ScrollToTop from './ScrollToTop'; // Import ScrollToTop component
// import Gallery from './Gallery';
import ImageGallery from './ImageGallery';
import VideoGallery from './VideoGallery';

import Facility from './Facility';
import PrivacyPolicy from './PrivacyPolicy';

const Navbar = () => {
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);

  const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);
  const handleNavItemClick = () => setIsNavCollapsed(true);

  return (
    <Router>
      <div>
        <ScrollToTop /> {/* Add the ScrollToTop component here */}
        <header>
          <nav className="navbar navbar-expand-lg navbar-light bg-light py-0">
            <div className="container" style={{ paddingTop: '5px', paddingBottom: '5px' }}>
              <Link className="navbar-brand" to="/" onClick={handleNavItemClick}>
                <span role="img" aria-label="Hello">
                  <img src={Logo} alt="" />
                </span>
              </Link>
              <button className="navbar-toggler" type="button" onClick={handleNavCollapse} aria-controls="navbarSupportedContent" aria-expanded={!isNavCollapsed} aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
              </button>
              <div className={`${isNavCollapsed ? 'collapse' : ''} navbar-collapse`} id="navbarSupportedContent">
                <ul className="navbar-nav ">
                  <li className="nav-item">
                    <Link className="nav-link active men-link ms-3" aria-current="page" to="/" onClick={handleNavItemClick} style={{color: '#603258'}}>Home</Link>
                  </li>
                   <li className="nav-item">
                    <Link className="nav-link women-link ms-3" to="/about" onClick={handleNavItemClick} style={{color: '#603258'}}>About Us</Link>
                  </li> 
                  <li className="nav-item">
                    <Link className="nav-link women-link ms-3" to="/our-treatment-facility" onClick={handleNavItemClick} style={{color: '#603258'}}>Facilities</Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link women-link ms-3" to="/image-gallery" onClick={handleNavItemClick} style={{color: '#603258'}}>Image - Gallery</Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link women-link ms-3" to="/video-gallery" onClick={handleNavItemClick} style={{color: '#603258'}}>Video - Gallery</Link>
                  </li> 
                 
                  <li className="nav-item">
                    <Link className="nav-link women-link ms-3" to="/contact-us" onClick={handleNavItemClick} style={{color: '#603258'}}>Contact Us</Link>
                  </li>
                  <button className="call-button">
                    <a rel="nofollow" className="component-target text-white" href="tel:+91 7535807012">
                      <i className="fa fa-phone"></i>
                      <span className="component-target-text">+91 7535807012</span>
                    </a>
                  </button>
                </ul>
              </div>
            </div>
          </nav>
        </header>
        <div className="main-content"> {/* Added this wrapper div */}
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/about" element={<About />} /> 
            <Route path="/our-treatment-facility" element={<Facility />} /> 

        
            <Route path="/image-gallery" element={<ImageGallery/>} />
            <Route path="/video-gallery" element={<VideoGallery/>} />

            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />



          </Routes>
        </div>
      </div>
    </Router>
  );
};

export default Navbar;
